import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { axiosClient } from '../../../core/axios-client'

const fetchTelegramLinkedChats = createAsyncThunk(
  'telegram/fetchLinkedChats',
  async ({ page = 1, page_size = 10 } = {}, { rejectWithValue }) => {
    try {
      const res = await axiosClient.get('/companies/selected/notifications/telegram/linked-chats', {
        params: { page, page_size }
      })
      return res.data
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message)
    }
  }
)

const fetchTelegramLinkedChat = createAsyncThunk(
  'telegram/fetchLinkedChat',
  async ({ chat_id }, { rejectWithValue }) => {
    try {
      const res = await axiosClient.get(`/companies/selected/notifications/telegram/linked-chats/${chat_id}`)
      return res.data
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message)
    }
  }
)

const fetchTelegramEventTypes = createAsyncThunk(
  'telegram/fetchEventTypes',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosClient.get('/companies/selected/notifications/telegram/linked-chats/event-types')
      return res.data
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message)
    }
  }
)

const patchTelegramLinkedChat = createAsyncThunk(
  'telegram/patchLinkedChat',
  async ({ chat_id, events }, { rejectWithValue }) => {
    try {
      const res = await axiosClient.patch(`/companies/selected/notifications/telegram/linked-chats/${chat_id}`, { events })
      return res.data
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message)
    }
  }
)

const deleteTelegramLinkedChat = createAsyncThunk(
  'telegram/deleteLinkedChat',
  async ({ chat_id }, { rejectWithValue }) => {
    try {
      await axiosClient.delete(`/companies/selected/notifications/telegram/linked-chats/${chat_id}`)
      return { chat_id }
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message)
    }
  }
)

const generateTelegramLink = createAsyncThunk(
  'telegram/generateLink',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosClient.get('/companies/selected/notifications/telegram/linked-chats/generate-link')
      return res.data
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message)
    }
  }
)

const initialState = {
  list: { items: [], page: 1, page_size: 10, count: 0 },
  current: null,
  eventTypes: [],
  loading: false,
  error: null
}

export const slice = createSlice({
  name: 'telegram',
  initialState,
  reducers: {
    setList(state, { payload }) {
      state.list = { ...state.list, ...payload }
    },
    resetCurrent(state) {
      state.current = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTelegramLinkedChats.fulfilled, (state, { payload }) => {
        const { results = [], count = 0 } = payload || {}
        state.list.items = results
        state.list.count = count
        state.loading = false
        state.error = null
      })
      .addCase(fetchTelegramLinkedChats.pending, (state) => { state.loading = true; state.error = null })
      .addCase(fetchTelegramLinkedChats.rejected, (state, { payload }) => { state.loading = false; state.error = payload })

      .addCase(fetchTelegramLinkedChat.fulfilled, (state, { payload }) => { state.current = payload })
      .addCase(fetchTelegramLinkedChat.rejected, (state, { payload }) => { state.error = payload })

      .addCase(fetchTelegramEventTypes.fulfilled, (state, { payload }) => { state.eventTypes = payload || [] })

      .addCase(patchTelegramLinkedChat.fulfilled, (state, { payload }) => {
        state.current = payload
        const idx = state.list.items.findIndex(it => String(it.id) === String(payload.id) || String(it.chat_id) === String(payload.chat_id))
        if (idx !== -1) state.list.items[idx] = payload
      })

      .addCase(deleteTelegramLinkedChat.fulfilled, (state, { payload }) => {
        state.list.items = state.list.items.filter(i => String(i.id) !== String(payload.chat_id) && String(i.chat_id) !== String(payload.chat_id))
      })

      .addCase(generateTelegramLink.fulfilled, (state, { payload }) => {
      })
  }
})

export {
  fetchTelegramLinkedChats,
  fetchTelegramLinkedChat,
  fetchTelegramEventTypes,
  patchTelegramLinkedChat,
  deleteTelegramLinkedChat,
  generateTelegramLink
}

export const { setList, resetCurrent } = slice.actions
export default slice.reducer